module.exports = function () {
    return Promise; // eslint-disable-line
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-defaults/src/$$promise.js
// module id = 546
// module chunks = 40